/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".toolbar[_ngcontent-%COMP%]{margin:5px;display:flex;justify-content:flex-start;align-items:center}.toolbar[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{margin-right:5px}"];
export { styles as styles };
